@import '~style-sheet-helpers/core.less';

.return-details-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  max-width: 1045px;
  min-width: 964px;
}

.return-details-wrapper-background {
  position: fixed;
  inset: 0;
  background: transparent;
}

.return-details-arrow-previous,
.return-details-arrow-next {
  position: relative;
  .vertical-align();
  width: 40px;
  height: 40px;
}

.return-details-arrow-previous {
  margin-right: 15px;
}

.return-details-arrow-next {
  margin-left: 15px;
}

.return-details-modal {
  align-self: center;
  margin: 0 55px;
  width: 100%;
}

.return-details-modal-body {
  height: 100%;
}
